'use client';

import { Box } from '@chakra-ui/react';
import { usePathname, useRouter } from 'next/navigation';
import React from 'react';

import styles from './new-search.module.scss';

interface ViewAllButtonProps {
  isVisible?: boolean;
}

export default function ViewAllButton({ isVisible = false }: ViewAllButtonProps) {
  const router = useRouter();
  const pathname = usePathname();
  
  const isSearchPage = pathname !== '/used-cars/search';
  
  if (!isSearchPage || !isVisible) {
    return null;
  }
  
  return (
    <Box display={{ lg: 'none', base: 'block' }} mt={2} className={styles.filtersActions}>
      <button
        type="button"
        onClick={() => router.push('/used-cars/search')}
        className={styles.viewAllBtn}
        data-cy="view-all-used-cars-button"
      >
        View All Used Cars
      </button>
    </Box>
  );
}